export default __webpack_public_path__ + "static/media/backend.51794d00.png";